export default __webpack_public_path__ + "b725e2f7699b50060636b9d3b1926c63.png";